var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMat = function SvgMat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.333 20.667v.5-.5ZM5.5 6V17h1V6h-1Zm0 11c0 .776.286 1.814 1.043 2.666.77.867 1.995 1.5 3.79 1.5v-1c-1.538 0-2.48-.532-3.043-1.165-.576-.649-.79-1.443-.79-2.001h-1Zm4.833 4.167H17.333v-1H10.332v1Zm7-.5v.5h.032a1.789 1.789 0 0 0 .259-.028c.158-.026.376-.08.6-.192a1.67 1.67 0 0 0 .65-.566c.186-.278.293-.627.293-1.048h-1c0 .246-.06.397-.125.494a.672.672 0 0 1-.266.226 1.139 1.139 0 0 1-.444.114h-.003.003l.001.5Zm1.834-1.334V7.333h-1V19.333h1Zm0-12c0-.521-.131-1.004-.48-1.353-.35-.35-.832-.48-1.354-.48v1c.368 0 .551.091.647.187.095.095.187.279.187.646h1ZM17.333 5.5H12.667v1H17.333v-1Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.667 6A3.333 3.333 0 0 0 6 6M12.667 16.7c0-1.491-1.493-3-3.334-3-1.84 0-3.333 1.509-3.333 3",
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.167 16.5a.5.5 0 0 0-1 0h1Zm-1 0a2.5 2.5 0 0 0 2.5 2.5v-1a1.5 1.5 0 0 1-1.5-1.5h-1Zm2.5 2.5a2.5 2.5 0 0 0 2.5-2.5h-1a1.5 1.5 0 0 1-1.5 1.5v1Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.667 6v10.7",
    stroke: "currentColor"
  })));
};
export { SvgMat as ReactComponent };
export default __webpack_public_path__ + "static/mat.3ce9a051.svg";